var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaisedrequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_96609)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 49.5661L39.3164 55L54.319 44.6086L54.5263 5.05051L19.8655 0L0 9.63154V49.5661Z",
    fill: "#C28F60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5263 5.05051L39.1789 15.3203L0 9.63155L19.8655 0L54.5263 5.05051Z",
    fill: "#AA7950"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3227 55.0003L39.1787 15.3205L54.5261 5.05078L54.9998 44.7638L39.3227 55.0003Z",
    fill: "#D2A06D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8297 1.01562L38.1831 2.66967L21.9313 13.0462L21.9216 31.0064L16.1391 26.7985L10.3555 30.2913L11.0773 11.4334L26.8297 1.01562Z",
    fill: "#65472F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_96609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisedrequestIcon);
export default __webpack_public_path__ + "static/media/raisedrequestIcon.205f3fae814351085d8fdb5aadbadbda.svg";
export { ForwardRef as ReactComponent };